import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/firestore'
import axios from 'axios'
import '@/assets/css/bootstrap.min.css'
import '@/assets/css/gl-styles.css'
import '@/assets/css/toggleTab.css'
import '@/assets/css/fns-css.css'
import '@/assets/css/font-awesome.min.css'
import '@/assets/css/login.css'
import '@/assets/css/util.css'
import '@/assets/css/main.css'
import '@/assets/css/style2.css'
import VModal from 'vue-js-modal'
import VueConfirmDialog from 'vue-confirm-dialog'
import VueSweetalert2 from 'vue-sweetalert2'
import { Swiper as SwiperClass, Pagination, Mousewheel, Autoplay } from 'swiper/swiper.esm'
import getAwesomeSwiper from 'vue-awesome-swiper/dist/exporter'
import VueClipboard from 'vue-clipboard2'
import i18n from './i18n'
import { installBuildVersionGuard } from '@/utils/buildVersionGuard'
VueClipboard.config.autoSetContainer = true // add this line
Vue.use(VueClipboard)
SwiperClass.use([Pagination, Mousewheel, Autoplay])
Vue.use(getAwesomeSwiper(SwiperClass))
const { Swiper, SwiperSlide } = getAwesomeSwiper(SwiperClass)
import 'swiper/swiper-bundle.css'
import 'sweetalert2/dist/sweetalert2.min.css';
const options = {
  confirmButtonColor: '#FFD74C',
  cancelButtonColor: '#ff7674'
}
Vue.use(VueSweetalert2, options)
Vue.use(VModal)
Vue.use(VueConfirmDialog)
Vue.component('vue-confirm-dialog', VueConfirmDialog.default)
const configFirebase = {
  apiKey: "AIzaSyDsCVI6jvVw_4--v4-rY-3xeWkJBXDV77U",
  authDomain: "time2-lucky.firebaseapp.com",
  databaseURL: "https://time2-lucky-default-rtdb.asia-southeast1.firebasedatabase.app",
  projectId: "time2-lucky",
  storageBucket: "time2-lucky.firebasestorage.app",
  messagingSenderId: "1085378899733",
  appId: "1:1085378899733:web:a96d919abc01d8b4bd831c"
}
firebase.initializeApp(configFirebase)
Vue.config.productionTip = false
Vue.prototype.$music = null
installBuildVersionGuard()
let app: any

type DomainAccessDomain = {
  host: string;
  active: boolean;
}

type DomainAccessConfig = {
  domains: DomainAccessDomain[];
  partnerReferralHost: string;
}

const DOMAIN_ACCESS_DOC_ID = 'domainAccess'
const LOCAL_DEVELOPMENT_HOSTS = ['localhost', '127.0.0.1', '::1']

const normalizeDomain = (value: string): string => {
  const rawValue = (value || '').toString().trim().toLowerCase()
  if (!rawValue) return ''

  return rawValue
    .replace(/^https?:\/\//, '')
    .replace(/^\/\//, '')
    .split('/')[0]
    .split('?')[0]
    .split('#')[0]
    .replace(/:\d+$/, '')
}

const normalizeDomainAccess = (data: any): DomainAccessConfig => {
  const seen: Record<string, boolean> = {}
  const domains = Array.isArray(data && data.domains) ? data.domains : []

  return {
    domains: domains.reduce((result: DomainAccessDomain[], domain: any) => {
      const host = normalizeDomain(domain && domain.host)
      if (!host || seen[host]) return result
      seen[host] = true
      result.push({
        host,
        active: domain && domain.active === true
      })
      return result
    }, []),
    partnerReferralHost: normalizeDomain(data && data.partnerReferralHost)
  }
}

const shouldBypassLocalDomainGate = (host: string): boolean => {
  return process.env.NODE_ENV !== 'production'
    && process.env.VUE_APP_DOMAIN_GATE_CHECK_LOCALHOST !== 'true'
    && LOCAL_DEVELOPMENT_HOSTS.includes(host)
}

const renderNotAvailable = () => {
  document.title = 'Not Available'
  const appElement = document.getElementById('app')
  if (!appElement) return

  appElement.innerHTML = `
    <main style="min-height:100vh;display:flex;align-items:center;justify-content:center;background:#0f1115;color:#fff;font-family:Arial,sans-serif;text-align:center;padding:24px;">
      <section>
        <h1 style="font-size:32px;margin:0 0 12px;">Not Available</h1>
        <p style="font-size:15px;margin:0;color:#b8beca;">This website is not available on this domain.</p>
      </section>
    </main>
  `
}

const checkDomainAccess = async (): Promise<boolean> => {
  const currentHost = normalizeDomain(window.location.hostname)
  if (shouldBypassLocalDomainGate(currentHost)) return true

  try {
    const domainAccessDoc = await firebase.firestore()
      .collection('settings')
      .doc(DOMAIN_ACCESS_DOC_ID)
      .get()

    if (!domainAccessDoc.exists) return false

    const domainAccess = normalizeDomainAccess(domainAccessDoc.data())
    store.commit('settings/SET_DOMAIN_ACCESS', domainAccess)

    if (!domainAccess.domains.length) return false

    return domainAccess.domains.some((domain) => domain.host === currentHost && domain.active === true)
  } catch (error) {
    console.error('Domain access check failed:', error)
    return false
  }
}

const mountApp = () => {
  firebase.auth().onAuthStateChanged((user) => {
    if (user) {
      user.getIdToken().then((token) => axios.post(
        'https://time2lucky.apifast.xyz/legacy-imi/first-login',
        {},
        { headers: { Authorization: `Bearer ${token}` }, timeout: 45000 }
      )).catch((error) => {
        console.warn('Legacy IMI migration check could not complete', error && error.response ? error.response.status : 'network')
      })
    }
    if (!app) {
      app = new Vue({
        i18n,
        router,
        store,
        render: h => h(App)
      }).$mount('#app')
    }
  })
}

checkDomainAccess().then((allowed) => {
  if (!allowed) {
    renderNotAvailable()
    return
  }

  mountApp()
})
